import React from 'react'

const NavItem = ({children}) => <div className={`font-accent uppercase font-bold text-sm ml-8 cursor-pointer flex items-center justify-center`}>{children}</div>

export { NavItem }
